<template>
  <div class="grid grid-cols-4 space-x-2 mb-1">
    <div class="col-span-1 flex flex-row space-x-2 items-center">
      <Button class="flex p-1 justify-center text-sm"
        color="blue"
        @click="searchStudents">
        Search Students
      </Button>
    </div>
    <div class="col-span-1 flex flex-row space-x-2 items-center">
      <div>Student(s)</div>
    </div>
    <div class="col-span-2 flex flex-row space-x-2 items-center">
      <input class="h-full w-3/4"
        placeholder="value"
        v-model="formValues.value.input"
        @change="() => {
          markPendingItem(formValues, 'value')
          valueChange()
        }"
      />
      <span
        v-if="pendingValue">
        *
      </span>
      <div class="grow"></div>
      <XButton class="bg-orange-200 p-1 w-4 h-4 justify-center"
        @click="() => {
          deleteKeyValue()
          valueDelete()
        }"
      />
    </div>
  </div>
</template>

<script>
import XButton from '../../XButton.vue'
import Button from '../../Button.vue'

import userManagementService from '../../../services/pages/userManagement.js'

export default {
  props: {
    defaultValue: Object,
    value: undefined,
  },
  components: {
    XButton,
    Button,
  },
  data() {
    return {
      formValues: {
        key: {
          current: 'student_ids',
          input: 'student_ids',
        },
        value: {
          current: undefined,
          input: undefined,
        },
      },

      pendingKey: false,
      pendingValue: false,
    }
  },
  methods: {
    deleteKeyValue() {
      this.$emit('deleteKeyValue')
    },
    updateValue() {
      this.$emit('input', this.formValues)
    },
    markPendingItem(item, type) {
      if (type === 'key') {
        this.pendingKey = true
      }
      else if (type === 'value') {
        this.pendingValue = true
      }
      this.$emit('markPending', item, type)
    },
    onAddExistingKey(existingKey) {
      this.formValues.key.input = existingKey
      this.$emit('markPending', this.formValues, 'key')
    },
    valueChange() {
      try {
        this.$emit('valueChange', 'student_ids', JSON.parse(this.formValues.value.input))
      }
      catch {
        this.$emit('valueChange', 'student_ids', this.formValues.value.input)
      }
    },
    valueDelete() {
      this.$emit('valueDelete', 'student_ids')
    },
    searchStudents() {
      userManagementService.openSelectorModal('student', (selectedStudent) => {
        // The raw v-model input field needs to stay a string.
        // It needs to behave like an array except for how the user will interact with it, which is as a string.

        if (this.formValues.value.input) {
          try {
            let jsonValue = JSON.parse(this.formValues.value.input)
            if (Array.isArray(jsonValue)) {
              jsonValue.push(selectedStudent.db_id)
              this.formValues.value.input = JSON.stringify(jsonValue)
            }
            else {
              this.formValues.value.input = JSON.stringify([...this.formValues.value.input, selectedStudent.db_id])
            }
          }
          catch {
            this.formValues.value.input = `[${selectedStudent.db_id}]`
          }
        }
        else {
          this.formValues.value.input = `[${selectedStudent.db_id}]`
        }
        this.valueChange()
        this.markPendingItem(this.formValues, 'value')
      })
    },
  },
  mounted() {
    // TODO: Fix this so that it won't break when the formValues are not direct reference to the
    //      defaultValue object
    this.formValues = this.defaultValue
    this.formValues.key.current = 'student_ids'
    this.formValues.key.input = 'student_ids'
  },
  watch: {
    value(newValue) {
      this.formValues = newValue
    },
    formValues() {
      this.updateValue()
    },
    defaultValue(newValue) {
      this.formValues = newValue
      this.formValues.key.current = 'student_ids'
      this.formValues.key.input = 'student_ids'
    },
  }
}
</script>
